import React from "react";

const YvooaIcon = ({
  size = 28,
  primaryColor = "#3b82f6",
  accentFrom = "#F9C642",
  accentTo = "#FFD700",
  className,
  title = "Yvooa",
}) => {
  const gradientId = React.useId();

  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={accentFrom} />
          <stop offset="100%" stopColor={accentTo} />
        </linearGradient>
      </defs>

      <polygon
        points="48,95 60,20 75,20"
        fill={primaryColor}
        style={{ filter: "drop-shadow(0 2px 6px #1976d2aa)" }}
      />
      <polygon
        points="28,20 50,45 45,65"
        fill={`url(#${gradientId})`}
        style={{ filter: "drop-shadow(0 2px 6px #1976d2aa)" }}
      />
    </svg>
  );
};

export default YvooaIcon;
